import { useGetTourReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function TourReport() {
  const { t } = useTranslation();

  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:tour_report')}
      usePivotQuery={useGetTourReports}
      isShowAllFilterCompleted
      defaultFilters={defaultFilters}
    />
  );
}
